export const ServiceTypes = {
  ErrorHandler: Symbol("ErrorHandler"),
  ConfigurationService: Symbol("ConfigurationService"),
  AuthenticationService: Symbol("AuthenticationService"),
  ApiService: Symbol("ApiService"),
  SystemApiService: Symbol("SystemApiService"),
  WomApiService: Symbol("WomApiService"),
  BaseballStore: Symbol("BaseballStore"),
  StatusStore: Symbol("StatusStore"),
  GolfBroadcastStore: Symbol("GolfBroadcastStore"),
  NotificationStore: Symbol("NotificationStore"),
};
